import services from './../../services/service'; // Service Class
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import Sidebar from './../Sidebar/index.vue'; // Sidebar
import HorizontalWidget from '../HorizontalWidget.vue'; // HorizontalWidget
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
import SearchBar from '../SearchBar.vue'; //Search Bar

let service = new services();

export default {
    name: 'Cnpros',
    data () {
        return {
            user: {},
            cnpros: {},
            cnpro: {},
            cnsurveys: {},
            request: {},
            activeRequest: false,
            search: {},
            search_result: "",
            search_message: "",
            panelFlag: false,
            addFlag: false,
            img_url: service.imageURL,
            img_cp_url: service.imageCNproURL,
            pag_cnpro_intv: service.pageCnproIntv,
            current_page: 0,
            reviews: {},
            review: {},
            rate: "",
            backgroundSize: 'contain',
            search_mode:false
        }
    },
    components: {
        'second-header': SecondHeader,
        'sidebar': Sidebar,
        'main-footer': MainFooter,
        'horizontal-widget': HorizontalWidget,
        'search-bar': SearchBar
    },
    computed: {
        rateValue: {
            get(){
                //this function will determine what is displayed in the input
                return this.rate;
            },
            set(newVal){
                //this function will run whenever the input changes
                this.rate = newVal;
                this.rateCnpro();
            }
        }
    },
    methods: {
        //settings
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_token")
            } 
           if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        }else {
                            this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
            
        },

        //--//settings
        isActive(page){
            if(page == this.current_page){
                return true;
            }
        },
       

        saveComponent(component) {
            this.cnpro = component;

            var credentials = {
                save_category: 1, // 1 for cnpros
                save_business: 0, //not a business
                save_cnpro: this.cnpro.cnpro_id,
                save_user: this.user.user_id || 'nill'
            }
            service.saveListing(this, credentials).then(function(data) {
            if(data.body.status == 201) {
                toastr.success('CNpro Saved!!', 'Success!');
            }else if(data.body.status == 400) {
                toastr.error('Sorry, could not process information', 'Warning!');        
            }else if(data.body.status == 500) {
               toastr.error(data.body.message, 'Warning!');  
            }else {
                toastr.error('Please Log In to Save', 'Warning!');        
            }
            })
        },

         //cnpros
        viewCnpro(cnpro){
           if(cnpro) {
                localStorage.setItem("cityneeds_search_cnpro", cnpro.cnpro_data_item); //use local storage for now
                this.$router.push("cnpro");
                //location.assign("cnpro")
           }
            
        },

      
        
        getAllCnprosX() {
           service.getAllCnpros(this).then(data => {
               if(data.body.status == 200) {
                    this.cnpros = data.body.data;
                   localStorage.setItem("cityneeds_cnsearch", data.body.data);
                }
            }).catch((err) => {
                if(err) {
                    //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getAllCnpros(offset,items) {
            service.getSearchCnpros(this,offset,items).then(data => {
                if(data.body.status == 200) {
                    this.cnpros = data.body.data;
                    if((data.body.data_count % this.pag_intv)){
                        this.cnpros.count_range = (Math.floor(data.body.data_count/this.pag_intv)+1);
                    }else if(data.body.data_count>this.pag_intv){
                        this.cnpros.count_range = Math.floor(data.body.data_count/this.pag_intv);
                    }
                     this.current_page = items;
                 }
             }).catch((err) => {
                 if(err) {
                     //toastr.error('Sorry, could not process information', 'Warning!');
                 }
             })
         },

         getSearchCnpros(offset,items) {
            var credentials = {
                search_type: 'cnpros',
                search_keywords: this.$route.query.context,
                search_city: this.$route.query.city
            }
                // this.search_result = localStorage.getItem("cityneeds_search_keywords");
                this.search_result = this.$route.query.context;
                service.searchCnpros(this, credentials, offset, this.pag_intv).then(function(data) {
                    if(data.body.status == 200) {
                        this.cnpros = data.body.data;
                        if((data.body.data_count % this.pag_intv)){
                            this.cnpros.count_range = (Math.floor(data.body.data_count/this.pag_intv)+1);
                        }else{thiscnpros.count_range = Math.floor(data.body.data_count/this.pag_intv);}
                         this.current_page = items;
                    }else if(data.body.status == 400 || data.body.status == 404) {
                        //do something here like redirect to advertised data 
                        this.search_message = "Sorry Could not get the Information of entry yet";            
                    }
                })
           
        },

        

        doSearch(){
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            }

            let navi = this.$router;

            if(credentials.search_type != null || credentials.search_keywords != null) {
                if(credentials.search_type == "businesses") {
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                    navi.push("business-search");
                }
                 else if(credentials.search_type == "cnpros") {
                    //use local storage for now
                    localStorage.setItem("cityneeds_search_type", this.search.type);
                    localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
                    localStorage.setItem("cityneeds_search_city", this.search.city);
                    navi.push("cnpro-search");
                   
                }
           }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }
        
        },
        
        //--//cnpros
        
       
    },
    created: function(){
        let u_t = localStorage.getItem("cityneeds_token");
        if((u_t != null)) {
            this.preset();
        }
       // this.getSearchCnpros();
       this.getAllCnpros(0,this.pag_intv);
       
    }
}


// WEBPACK FOOTER //
// ./src/components/Cnpros/script.js